var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"node"},[_c('i',{staticClass:"icon"},[_vm._v("#")]),_c('span',{attrs:{"contenteditable":"true"}})])
}]

export { render, staticRenderFns }